export default [
  { title: "Api Settings", icon: "ri-home-4-line", link: "/send-money" },
  { title: "Documentation", icon: "ri-wallet-line", link: "/receive-money" },
  { title: "Support", icon: "ri-file-edit-line", link: "/transaction-money" },
];
